import { channelProgramApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CHANNEL_PROGRAMS_ACTION_TYPE = createNamedActions('channelPrograms', {
  GET_CHANNEL_PROGRAMS: 'GET_CHANNEL_PROGRAMS',
  EDIT_CHANNEL_PROGRAMS: 'EDIT_CHANNEL_PROGRAMS',
  RESET_CHANNEL_PROGRAMS: 'RESET_CHANNEL_PROGRAMS',
});

export const getChannelProgramsAction = catchAsyncActionError((params = {}) => async dispatch => {
  const { data } = await channelProgramApi.getChannelPrograms(params);

  return dispatch({
    type: CHANNEL_PROGRAMS_ACTION_TYPE.GET_CHANNEL_PROGRAMS,
    payload: data,
  });
});

export const editChannelProgramsAction = params => async dispatch => {
  const { data } = await channelProgramApi.editChannelPrograms(params);

  return dispatch({
    type: CHANNEL_PROGRAMS_ACTION_TYPE.EDIT_CHANNEL_PROGRAMS,
    payload: data,
  });
};

export const resetChannelProgramsAction = params => async dispatch => {
  const { data } = await channelProgramApi.deleteChannelPrograms(params);

  return dispatch({
    type: CHANNEL_PROGRAMS_ACTION_TYPE.RESET_CHANNEL_PROGRAMS,
    payload: data,
  });
};
